export default "__VITE_ASSET__BgkJGwbx__"